"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authEvents = void 0;
var eventemitter2_1 = require("eventemitter2");
var nanoid_1 = require("nanoid");
var socket_io_client_1 = require("socket.io-client");
var storage_1 = __importDefault(require("../../ui-shared-lite/utils/storage"));
exports.authEvents = new eventemitter2_1.EventEmitter2();
var getStorageKey = function (userIdScope) { return (userIdScope ? "bp/socket/".concat(userIdScope, "/user") : 'bp/socket/user'); };
var unsetVisitorId = function (userIdScope) {
    storage_1.default.del(getStorageKey(userIdScope));
    window.__BP_VISITOR_ID = undefined;
};
var setVisitorId = function (userId, userIdScope) {
    if (typeof userId === 'string' && userId !== 'undefined') {
        storage_1.default.set(getStorageKey(userIdScope), userId);
        window.__BP_VISITOR_ID = userId;
    }
};
var getUniqueVisitorId = function (userIdScope) {
    var key = getStorageKey(userIdScope);
    var userId = storage_1.default.get(key);
    if (typeof userId !== 'string' || userId === 'undefined') {
        userId = (0, nanoid_1.nanoid)(24);
        storage_1.default.set(key, userId);
    }
    window.__BP_VISITOR_ID = userId;
    return userId;
};
var EventBus = /** @class */ (function (_super) {
    __extends(EventBus, _super);
    function EventBus() {
        var _this = _super.call(this, { wildcard: true, maxListeners: 100 }) || this;
        _this.dispatchSocketEvent = function (event) {
            _this.emit(event.name, event.data, 'server');
        };
        _this.dispatchClientEvent = function (name, data, from) {
            if (from === 'server') {
                // we sent this event ourselves
                return;
            }
            var socket = _this.guestSocket;
            socket && socket.emit('event', { name: name, data: data });
        };
        _this.deleteVisitorId = function (userIdScope) {
            unsetVisitorId(userIdScope);
        };
        _this.updateVisitorId = function (userId, userIdScope) {
            setVisitorId(userId, userIdScope);
        };
        _this.setup = function (userIdScope) {
            var query = {
                visitorId: getUniqueVisitorId(userIdScope)
            };
            if (_this.guestSocket) {
                _this.guestSocket.off('event', _this.dispatchSocketEvent);
                _this.guestSocket.off('connect', _this.updateVisitorSocketId);
                _this.guestSocket.disconnect();
                _this.deleteVisitorSocketId();
            }
            var socketUrl = window['BP_SOCKET_URL'] || window.location.origin;
            var transports = window.SOCKET_TRANSPORTS;
            _this.guestSocket = (0, socket_io_client_1.io)("".concat(socketUrl, "/guest"), { query: query, transports: transports, path: "".concat(window['ROOT_PATH'], "/socket.io") });
            _this.guestSocket.on('connect', _this.updateVisitorSocketId.bind(_this));
            _this.guestSocket.on('event', _this.dispatchSocketEvent);
        };
        _this.onAny(_this.dispatchClientEvent);
        exports.authEvents.on('new_token', _this.setup);
        return _this;
    }
    EventBus.prototype.updateVisitorSocketId = function () {
        window.__BP_VISITOR_SOCKET_ID = this.guestSocket.id;
    };
    EventBus.prototype.deleteVisitorSocketId = function () {
        window.__BP_VISITOR_SOCKET_ID = undefined;
    };
    return EventBus;
}(eventemitter2_1.EventEmitter2));
EventBus.default = new EventBus();
exports.default = EventBus;
